interface CommentMetaResponse {
    success: boolean;
    message?: string;
    data?: any;
}

const addCommentMetas = async (
    commentId: number,
    metaKey: string,
    metaValue: any,
): Promise<CommentMetaResponse> => {
    const response = await fetch('/api/post/update-comment-meta', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            commentId,
            metaKey,
            metaValue,
        }),
    });

    if (!response.ok) {
        // status lets callers tell «log in first» (401) from other failures
        throw Object.assign(new Error(`HTTP error! Status: ${response.status}`), {
            status: response.status,
        });
    }

    return await response.json();
};

export default addCommentMetas;
